export default __webpack_public_path__ + "static/media/Mockup_Report-CommsCoaching.1cfbe4ec.jpg";